<script>
import {mapState, mapActions} from "pinia";
import {authStore} from "@/store/authStore";
import {profileStore} from "@/store/profileStore";
import BaseLayout from "@/components/BaseLayout.vue";
import BaseTab from "@/components/BaseTab.vue";
import ProfileEditGeneral from "@/views/profile/ProfileEdit/ProfileEditGeneral.vue";
import ProfileEditPicture from "@/views/profile/ProfileEdit/ProfileEditPicture.vue";

export default {
  name: "ProfileEditView",
  components: {
    BaseLayout,
    BaseTab,
    ProfileEditGeneral,
    ProfileEditPicture
  },
  data() {
    return {
      activeTab: null,
      editProfileData: null
    }
  },
  computed: {
    ...mapState(authStore, [
      'permissionUserRole',
      'userInfo',
      'userActiveProfile',
      'userProfiles',
      'getUserAccounts',
      'politicianIsVerified'
    ]),
    tabs() {
      return [
        { label: `General`, code: 'EDIT_PROF_GEN' }
        // { label: `Profile picture`, code: 'EDIT_PROF_PIC' }
      ]
    }
  },
  methods: {
    ...mapActions(profileStore, [
      'getMemberProfile',
      'getPoliticianProfile',
    ]),
    initEditProfileView() {
      const memberProfile = this.userProfiles.find(profile => profile.type === 'MEMBER');
      const politicianProfile = this.userProfiles.find(profile => profile.type === 'POLITICIAN');

      this.getMemberProfile(memberProfile.profileId);
      if (politicianProfile) {
        this.politicianProfileId = politicianProfile.profileId
        this.getPoliticianProfile(politicianProfile.profileId);
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
  },
  beforeMount() {
    this.initEditProfileView();
    this.activeTab = this.tabs[0];
  }
}
</script>

<template>
<base-layout>
  <div class="profile-edit-view">
    <div class="profile-edit-main">
      <span class="profile-edit-title">{{$t('profile.editProfile')}}</span>
      <div class="d-flex">
        <div class="profile-edit-tabs">
          <base-tab v-for="tab in tabs"
                    :key="tab.code"
                    :label="tab.label"
                    :active="tab.code === activeTab.code"
                    :alignment="'VERTICAL'"
                    @click="setActiveTab(tab)"
          />
        </div>
        <div class="profile-edit-content">
          <profile-edit-general v-show="activeTab.code === 'EDIT_PROF_GEN'"/>
          <profile-edit-picture v-show="activeTab.code === 'EDIT_PROF_PIC'"/>
        </div>
      </div>
    </div>
  </div>
</base-layout>
</template>

<style lang="scss" scoped>
.profile-edit-view {
  .profile-edit-main {
    width: 600px;
    .profile-edit-title {
      display: inline-block;
      margin-bottom: 15px;
      font-family: 'Open Sans', Arial, sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;
      color: #000;
    }
  }
  .profile-edit-tabs {
    width: 110px;
    .base-tab {
      background: transparent;
      &--active {
        background: #fff;
      }
    }
  }
  .profile-edit-content {
    width: 490px;
    background: #fff;
  }
}
</style>